module.exports = __webpack_public_path__ + "img/2020_IMG-035617cf1db95b67d8e0c5a4aff49253-V.179fc533.jpg";